<div [formGroup]="formGroup.form">
  <z-popup-lov
    [list]="carrierList$ | async"
    [fieldName]="fieldName"
    [label]="label"
    [placeholder]="placeholder"
    [hint]="hint"
    [buttonAction]="openDialog"
    [readonly]="readonly"
    [disabled]="disabled"
    [uppercase]="uppercase"
    [clearButton]="clearButton"
    [manualInput]="manualInput"
    [enableDropdown]="enableDropdown"
    [showDropdownFilter]="showDropdownFilter"
    [doubleClickToOpenPopup]="doubleClickToOpenPopup"
    (change)="onChangeHandler($event)"
    (dropdownSelectedOptionChange)="onSelectedOptionChangeHandler($event)"
    (clear)="onClearHandler($event)"
    [dropdownPanelMinWidth]="350"
    [columnsConfig]="{ column1: { width: 80 } }"
    [virtualScroll]="true"
    [dropdownFilterBy]="dropdownFilterBy"
  >
  </z-popup-lov>
</div>
